import * as React from 'react';
import { SlideDownTransition, UrlParams } from './';
import { mainConnection } from '../socket';
import { verticalCenter, media, clearFunctions } from '../util';
import MediaQuery from 'react-responsive';
import {
  writeToLocalStorage,
  writeToSessionStorage,
  getSettingByKey,
} from '../util/configHelper';
import { Input } from './input';
import _ from 'lodash';

export let loginEvents = {
  fail(text: string) {},
};

/** Message bar thing for feedback. */
function MessageBar({ text }: { text?: string }) {
  return (
    <SlideDownTransition show={!!text}>
      <div className="login-message error-message">{text}</div>
    </SlideDownTransition>
  );
}

interface ConnectScreenProps {
  params: UrlParams;
}

interface ConnectScreenState {
  deviceId?: string;
  message?: string;
  serverId?: string;
  connecting?: boolean;
}

/** Connection entry screen. */
export class ConnectScreen extends React.Component<
  ConnectScreenProps,
  ConnectScreenState
> {
  constructor(props, context) {
    super(props, context);

    let deviceUuid: string | undefined;

    if (this.props.params.device_uuid) {
      deviceUuid = this.props.params.device_uuid;

      writeToLocalStorage('last-device-id', this.props.params.device_uuid);
      writeToSessionStorage('last-device-id', this.props.params.device_uuid);

      writeToSessionStorage(
        'last-customer-name',
        this.props.params.customer_name || '',
      );

      writeToSessionStorage(
        'last-device-name',
        this.props.params.device_name || '',
      );

      if (!!this.props.params.asset_id) {
        const assetIdUuidDict = getSettingByKey('asset-id-uuid-dict') || {};

        const oldData = assetIdUuidDict[this.props.params.asset_id] || {
          customerName: '',
          deviceName: '',
        };

        const newDictPart = {
          [this.props.params.asset_id]: {
            deviceUuid: this.props.params.device_uuid,
            customerName:
              this.props.params.customer_name || oldData.customerName,
            deviceName: this.props.params.device_name || oldData.deviceName,
          },
        };

        const newDict = { ...assetIdUuidDict, ...newDictPart };

        writeToLocalStorage('asset-id-uuid-dict', newDict);
      }
    }

    if (!deviceUuid && !!this.props.params.asset_id) {
      const assetIdUuidDict = getSettingByKey('asset-id-uuid-dict');

      if (this.props.params.asset_id in assetIdUuidDict) {
        const data = assetIdUuidDict[this.props.params.asset_id];

        deviceUuid = data.uuid;

        writeToSessionStorage('last-customer-name', data.customerName || '');

        writeToSessionStorage('last-device-name', data.deviceName || '');

        writeToSessionStorage('last-device-id', data.deviceUuid || '');
      }
    }

    if (!deviceUuid) {
      deviceUuid = getSettingByKey('last-device-id');
    }

    this.state = {
      deviceId: deviceUuid,
    };
  }
  componentDidMount() {
    loginEvents.fail = (text: string) => {
      this.setState({ message: text, connecting: false });
    };

    if (this.state.deviceId) {
      mainConnection.connect(this.state.deviceId, 'nilAPIKeyPlaceholder');
    }
  }
  componentWillUnmount() {
    clearFunctions(loginEvents);
  }
  message(text: string) {
    if (text) {
      return <div className="login-message error-message">{text}</div>;
    }
    return null;
  }
  banner() {
    if (process.env.SYNCRO) {
      return (
        <div className="syncro-banner">
          <div>
            <img
              className="syncro-full-logo-icon"
              src={require('img/syncro-full-logo.png')}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="kabuto-live-banner">
          <div>
            <div className="logo-icon" />
            <div className="kabuto-live-banner-text"> KABUTO </div>
          </div>
        </div>
      );
    }
  }
  inner() {
    return (
      <div className="login-panel">
        {this.banner()}
        <MessageBar text={this.state.message} />
      </div>
    );
  }
  serverIdInput() {
    return (
      <Input
        type="text"
        value={this.state.serverId}
        placeholder="server ID"
        onChange={e => {
          this.setState({ serverId: (e.target as HTMLInputElement).value });
        }}
      />
    );
  }
  connect = () => {
    this.setState({ message: '', connecting: true });
    mainConnection.connect(this.state.deviceId, '');
  };
  render() {
    return (
      <div>
        <MediaQuery minWidth={media.sm.min}>
          <div style={_.assign(verticalCenter(400, 200))}>{this.inner()}</div>
        </MediaQuery>
        <MediaQuery maxWidth={media.xs.max}>
          <div style={_.assign(verticalCenter('80%', 300))}>{this.inner()}</div>
        </MediaQuery>
      </div>
    );
  }
}
